module.exports = __webpack_public_path__ + "ea84ee7c7c576223111a5f022766f935.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/zgfzb_g.png
// module id = 818
// module chunks = 3